/**
 * Csv Schema of AlertaCarga
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {AlertaCarga} from '@/model/resource/AlertaCarga'

/* TODO: review generated schema */
export class CsvAlertaCargaSchema extends Schema {
  readonly name = 'CsvAlertaCarga'

  readonly fieldSet: FieldSet<AlertaCarga> = {
    idAlertaCargaPk: schema => schema.model.idAlertaCargaPk,
    alerta: schema => schema.model.alerta?.$id ?? null,
    carga: schema => schema.model.carga?.$id ?? null,
    motorista: schema => schema.model.motorista?.$id ?? null,
    dataAlerta: schema => Helper.datetime(schema.model.dataAlerta),
  }
}
